import React, { useState, useEffect } from 'react';
import { FaRobot, FaLightbulb, FaChartLine } from 'react-icons/fa';

const AIAdvisor = ({ simulationData, model }) => {
  const [advice, setAdvice] = useState('');
  const [insightMode, setInsightMode] = useState('efficiency'); // efficiency, learning, optimization
  
  useEffect(() => {
    if (!simulationData) return;
    
    // Generate advice based on current simulation state
    generateAdvice(simulationData, model, insightMode);
  }, [simulationData, insightMode]);
  
  const generateAdvice = (data, model, mode) => {
    switch (mode) {
      case 'efficiency':
        if (data.efficiency < 0.7) {
          setAdvice('Efficiency is below optimal levels. Consider reducing slip or adjusting load.');
        } else if (data.rotorPower > model.ratedPower * 0.4) {
          setAdvice('High rotor power detected. This is an ideal scenario for slip power recovery.');
        } else {
          setAdvice('System is operating within optimal efficiency parameters.');
        }
        break;
        
      case 'learning':
        if (model.driveType === 'scherbius') {
          setAdvice('The Scherbius drive uses power electronics to convert AC rotor power to DC and then back to AC for grid return.');
        } else {
          setAdvice('The Kramer drive uses a DC motor mechanically coupled to recover slip energy.');
        }
        break;
        
      case 'optimization':
        // Suggest optimal parameters
        const optimalSlip = 0.2 + (model.loadTorque / 500) * 0.1;
        setAdvice(`For current load conditions, optimal slip would be approximately ${(optimalSlip * 100).toFixed(1)}%.`);
        break;
    }
  };
  
  return (
    <div className="ai-advisor glass-panel">
      <div className="advisor-header">
        <FaRobot size={24} />
        <h3>AI Advisor</h3>
        <div className="mode-selector">
          <button 
            className={insightMode === 'efficiency' ? 'active' : ''}
            onClick={() => setInsightMode('efficiency')}
          >
            <FaChartLine /> Efficiency
          </button>
          <button 
            className={insightMode === 'learning' ? 'active' : ''}
            onClick={() => setInsightMode('learning')}
          >
            <FaLightbulb /> Learning
          </button>
          <button 
            className={insightMode === 'optimization' ? 'active' : ''}
            onClick={() => setInsightMode('optimization')}
          >
            <FaChartLine /> Optimization
          </button>
        </div>
      </div>
      <div className="advice-content">
        {advice}
      </div>
    </div>
  );
};

export default AIAdvisor;